<loading [loader]="yukleniyor">

    <div class="content d-flex flex-column flex-column-fluid" id="kt_content" *ngIf="kullaniciTalepNebis!=null">
        <div class="toolbar mb-5">
            <div class="container-fluid d-flex flex-stack">
                <div class="page-title d-flex flex-column align-items-start me-3 mb-5 mb-lg-0">
                    <h3 class="d-flex text-dark fw-bolder fs-3 flex-column mb-0">
                        <span><i class="fas fa-tasks text-success me-2" style="font-size: large;"></i><span></span>
                            Talep Ayrıntı </span>
                    </h3>
                </div>
                <div class="d-flex align-items-center gap-2 gap-lg-3">
                </div>
            </div>
        </div>
        <div id="kt_content_container" class="mx-10 justify-content-center">

            <div class="row gy-5 g-xl-12">
                <!--begin::Col-->
                <div class="col-xxl-5 mb-5 mb-xl-12">
                    <!--begin::Row-->
                    <div class="row gx-5 gx-xl-12">
                        <!--begin::Col-->
                        <div class="col-sm-12 mb-5 mb-xl-10">
                            <!--begin::List widget 1-->
                            <div class="card card-flush h-lg-100">
                                <!--begin::Header-->
                                <div class="card-header pt-5" style="border-top: 2px blue solid;">
                                    <!--begin::Title-->
                                    <h3 class="card-title align-items-start flex-column">
                                        <span class="card-label fw-bolder text-dark"><i
                                                class="far fa-address-book text-success me-2"
                                                style="font-size: larger;"></i> <b>Talep Haraketleri</b></span>
                                        <span class="text-gray-400 mt-1 fw-bold fs-6"></span>
                                    </h3>
                                    <!--end::Title-->
                                    <!--begin::Toolbar-->
                                    <div class="card-toolbar">
                                        <!--begin::Menu-->
                                        <button
                                            class="btn btn-icon btn-color-gray-400 btn-active-color-primary justify-content-end"
                                            data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                                            data-kt-menu-overflow="true">
                                            <!--begin::Svg Icon | path: icons/duotune/general/gen023.svg-->
                                            <span class="svg-icon svg-icon-1">
                                               
                                            </span>  
                                            <!--end::Svg Icon-->
                                        </button>
                                        <!--begin::Menu 2-->

                                        <!--end::Menu 2-->
                                        <!--end::Menu-->
                                    </div>
                                    <!--end::Toolbar-->
                                </div>
                                <!--end::Header-->
                                <!--begin::Body-->

                                <div class="card-body pt-5">
                                    <div class="card card-xl-stretch">
                                        <div class="timeline-label">
                                            <!--begin::Item-->
                                            <div class="timeline-item"
                                                *ngFor="let item of kullaniciTalepNebis?.hareketBilgileri;let i=index;">
                                                <!--begin::Label-->
                                                <div class="timeline-label fw-bolder text-gray-800 fs-6 flex-shrink-0">
                                                    {{item?.kayitTarihi |
                                                    date:'HH:mm'}}
                                                </div>
                                                <!--end::Label-->
                                                <!--begin::Badge-->
                                                <div class="timeline-badge col-1">
                                                    <i class="fa fa-genderless text-{{haraketRenk[i%4].renk}} fs-1"></i>
                                                </div>
                                                <!--end::Badge-->
                                                <!--begin::Text-->
                                                <div class="fw-mormal timeline-content fs-6 ps-3 col-5">
                                                    <b> {{item?.kayitTarihi |
                                                        date:'dd.MM.yyyy'}}</b> &nbsp; &nbsp; <span
                                                        style="color: #8839EA; font-size: medium;">{{item?.durumAdi }}
                                                        <i  *ngIf="item?.okundumu==1; else okunmadi"  title="Süreç görüldü." class="fas fa-check-double  fs-4" style="color: blue;float: right;padding: 6px 0;"></i>
                                                        <ng-template #okunmadi>
                                                            <i class="fas fa-check text-danger fs-4" style="color: red;float: right; padding: 6px 0;" title="Süreç görülmedi."></i>
                                                        </ng-template>
                                                    </span>
                                                    <br>
                                                    <span class="card-label  text-dark fs-6 me-2">{{item?.aciklama
                                                        }}  </span>
                                                    <br>
                                                    <!-- <span class="card-label fw-bolder text-dark fs-6 me-2">
                                                        <ng-container *ngIf="item?.eposta==1;else drmENo;">E-posta
                                                            bilgilendirme :&nbsp; <i
                                                                class="fas fa-check  text-success fs-6"></i>
                                                        </ng-container>
                                                        <ng-template #drmENo>
                                                            <ng-container *ngIf="item?.eposta==2">E-posta bilgilendirme
                                                                :&nbsp; <i
                                                                    class="fas fa-times fs-4 text-danger fs-4"></i>
                                                            </ng-container>
                                                        </ng-template>
                                                    </span> -->
                                                    <span class="card-label fw-bolder text-dark fs-6 ">
                                                        <ng-container *ngIf="item?.sms==1;else drmSmsNo;">Sms
                                                            bilgilendirme  :&nbsp; <i
                                                                class="fas fa-check  text-success fs-6"></i>
                                                        </ng-container>
                                                        <ng-template #drmSmsNo>
                                                            <ng-container *ngIf="item?.sms==2">Sms bilgilendirme :&nbsp;
                                                                <i class="fas fa-times fs-4 text-danger fs-4"></i>
                                                            </ng-container>
                                                        </ng-template>
                                                    </span>
                                                    <span class="card-label fw-bolder text-dark fs-6 "
                                                        *ngIf="item?.dosya!=''">
                                                        Haraket Dosyası :&nbsp; <i
                                                            class="far fa-file fs-4 text-success me-2"></i><a
                                                            class="menu-link cursor-pointer"
                                                            (click)="dosyaIndirNebis(kullaniciTalepNebis.id,item.id)">Dosyayı
                                                            İndir</a>
                                                        <span *ngIf="this?.indiriliyorHar && item?.dosya!=''"
                                                            class="ms-2 text-success"> <span
                                                                class="spinner-border spinner-primary spinner-border-lg align-middle text-success"></span>
                                                            Dosya İndiriliyor...</span>
                                                    </span>

                                                </div>
                                                <!--end::Text-->
                                            </div>


                                        </div>
                                    </div>
                                </div>
                                <!--end::Body-->
                            </div>
                            <!--end::LIst widget 1-->
                        </div>
                        <!--end::Col-->
                        <!--begin::Col-->

                        <!--end::Col-->
                    </div>
                </div>
                <!--end::Col-->
                <!--begin::Col-->
                <div class="col-xxl-7 mb-5 mb-xl-12">
                    <!--begin::Chart widget 8-->
                    <div class="card card-flush h-xl-100" style="border-top: 2px #00ABD8 solid;">
                        <!--begin::Header-->
                        <div class="card-header pt-5">
                            <!--begin::Title-->
                            <h3 class="card-title align-items-start flex-column">
                                <span class="card-label fw-bolder text-dark">Talep Detayları</span>

                            </h3>
                            <!--end::Title-->
                            <!--begin::Toolbar-->
                            <div class="card-toolbar">
                                <span class="svg-icon svg-icon-2">
                                    <i class="fas fa-book text-success" style="font-size: x-large;"></i>
                                </span>
                            </div>
                            <!--end::Toolbar-->
                        </div>
                        <!--end::Header-->
                        <!--begin::Body-->
                        <div class="card-body pt-0">
                            <!--begin::Tab content-->
                            <div class="my-5">
                                <div class="form-group row mb-2">
                                    <label class="col-3 fw-bold text-info fs-5">Talep No</label>
                                    <div class="col-9">
                                        <input style="border-color: #8fb9d5;" class="form-control form-control-solid" type="text" readonly
                                            value={{kullaniciTalepNebis?.id}}>
                                    </div>
                                </div>
                                <div class="form-group row mb-2">
                                    <label class="col-3 fw-bold text-info fs-5">Sorumlu Birim</label>
                                    <div class="col-9">
                                        <input style="border-color: #8fb9d5;" class="form-control form-control-solid" type="text" readonly
                                            value={{kullaniciTalepNebis?.birimAdi}}>
                                    </div>
                                </div>

                                <div class="form-group row mb-2">
                                    <label class="col-3 fw-bold text-info fs-5">Talep Kategorisi</label>
                                    <div class="col-9">
                                        <input style="border-color: #8fb9d5;" class="form-control form-control-solid" type="text" readonly
                                            value={{kullaniciTalepNebis?.talepKategoriAdi}}>
                                    </div>
                                </div>

                                <div class="form-group row mb-2">
                                    <label class="col-3 fw-bold text-info fs-5">Talep Açıklaması
                                    </label>
                                    <div class="col-9">
                                        <textarea style="border-color: #8fb9d5;" class="form-control form-control-solid" readonly maxlength="1000"
                                            rows="10">{{kullaniciTalepNebis?.aciklama}}</textarea>
                                    </div>
                                </div>

                                <div class="form-group row mb-2">
                                    <label class="col-3 fw-bold text-info fs-5">Talep Durumu</label>
                                    <div class="col-9">
                                        <div style="border-color: #8fb9d5;" class="input-group input-group-solid">
                                            <input style="border-color: #8fb9d5;" type="text" class="form-control form-control-solid" readonly
                                                value="{{kullaniciTalepNebis?.durumAdi}}">
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row mb-2">
                                    <label  class="col-3 fw-bold text-info fs-5">Talep Tarihi</label>
                                    <div class="col-9">
                                        <div class="input-group input-group-solid">
                                            <input style="border-color: #8fb9d5;" type="text" class="form-control form-control-solid" readonly value="{{kullaniciTalepNebis?.sonGuncellemeTarihi |
                                    date:'dd.MM.yyyy HH:mm'}} ">
                                            <div class="input-group-append">
                                                <span  class="input-group-text"><i
                                                        class="far fa-calendar-alt text-success fs-4"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row mb-2">
                                    <label class="col-3 fw-bold text-info fs-5">Sonuç Durumu</label>
                                    <div class="col-9">
                                        <div class="input-group input-group-solid">                                     
                                            <div class="d-flex align-items-center bg-light-danger rounded p-5">
                                                <!--begin::Icon-->
                                                <span class="svg-icon svg-icon-danger me-5">
                                                    <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                                                    <span class="svg-icon svg-icon-1">
                                                        <i class="fas fa-poll text-info" style="font-size: large;"></i>
                                                    </span>
                                                    <!--end::Svg Icon-->
                                                </span>
                                                <!--end::Icon-->
                                                <!--begin::Title-->
                                                <div class="flex-grow-1 me-2">
                                                       <span  class="fw-bolder text-gray-800  fs-6" *ngIf="kullaniciTalepNebis?.durumAdi!='İptal Edildi';">
                                                        <ng-container *ngIf="kullaniciTalepNebis?.kapatildimi==0;else drmNo1;">
                                                            <input style="border-color: #8fb9d5;" type="text" class="form-control form-control-solid" readonly
                                                                value="">
                                                        </ng-container>
                                                        <ng-template #drmNo1>
                                                            <ng-container
                                                                *ngIf="kullaniciTalepNebis?.kapatildimi==1 && kullaniciTalepNebis?.olumlumu==1; else drmNo2">
                                                                <b><span class="fs-5">Kapatıldı.
                                                                        Olumlu <i
                                                                            class="fas fa-check fs-4 text-success"></i></span>
                                                                </b>
                                                            </ng-container>
                                                        </ng-template>
                                                        <ng-template #drmNo2>
                                                            <ng-container
                                                                *ngIf="kullaniciTalepNebis?.kapatildimi==1 && kullaniciTalepNebis?.olumlumu==0">
                                                                <b><span class="fs-5">Kapatıldı.
                                                                        Olumsuz <i
                                                                            class="fas fa-times fs-4 text-danger"></i></span>
                                                                </b>
                                                            </ng-container>
                                                        </ng-template>
                                                    </span>
                                                    <span class="text-muted fw-bold d-block"></span>
                                                </div>
                                                <!--end::Title-->
                                                <!--begin::Lable-->
                                                <span class="fw-bolder text-danger py-1"></span>
                                                <!--end::Lable-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- <div class="form-group row mb-2">
                                    <label class="col-3 fw-bold text-info">E-posta Bilgilendirme</label>
                                    <div class="col-9">
                                        <div class="input-group input-group-solid">
                                            <span class="input-group-text">
                                                <i *ngIf="kullaniciTalepNebis?.eposta; else carpi"
                                                    class="fas fa-check text-success fs-4"></i>
                                                <ng-template #carpi>
                                                    <i class="fas fa-times fs-4 text-danger"></i>
                                                </ng-template>
                                            </span>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="form-group row mb-2">
                                    <label class="col-3 fw-bold text-info fs-5">SMS Bilgilendirme</label>
                                    <div class="col-9">
                                        <div class="input-group input-group-solid">
                                            <span class="input-group-text">
                                                <i *ngIf="kullaniciTalepNebis?.sms; else carpi"
                                                    class="fas fa-check text-success fs-4"></i>

                                                <ng-template #carpi>
                                                    <i class="fas fa-times fs-4 text-danger fs-4"></i>
                                                </ng-template>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row mb-2">
                                    <label class="col-3 fw-bold text-info fs-5">Yüklenen Dosya</label>
                                    <div class="col-9">
                                        <div class="input-group input-group-solid"
                                            *ngIf="kullaniciTalepNebis?.dosya!=''">
                                            <label class="col-form-label text-left fs-6 text-info"><span
                                                    style="color: red;">
                                                    <a class="menu-link cursor-pointer" [class.disabled]="true"
                                                        (click)="dosyaIndirNebis(kullaniciTalepNebis.id,0)">{{ dosyaAd
                                                        }}</a> </span></label>

                                            <div class="input-group-append">
                                                <span class="input-group-text"><i
                                                        class="far fa-file fs-4 text-success"></i>
                                                    <span *ngIf="this?.indiriliyor && kullaniciTalepNebis?.dosya!=''"
                                                        class="ms-2 text-success"> <span
                                                            class="spinner-border spinner-primary spinner-border-lg align-middle text-success"></span>
                                                        Dosya İndiriliyor...</span> </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="form-group text-center">
                                    <button type="button" routerLink="/talep-list" id="kt_modal_new_target_cancel"
                                        class="btn btn-success btn-sm btn-hover-rise me-3">
                                        <i class="fas fa-list"></i>
                                        Talep Listesi </button>
                                </div>
                            </div>
                            <!--end::Tab content-->
                        </div>
                        <!--end::Body-->
                    </div>
                    <!--end::Chart widget 8-->
                </div>
                <!--end::Col-->
            </div>

        </div>
    </div>

</loading>